
import axiosInstance from '../axiosInstance';
import { useEffect, useMemo, useState, useRef } from 'react';
import { FaDownload } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import Paging from '../components/Paging';
import CheckingReview from '../components/orders/CheckingReview';
import UserLayout from "../components/UserLayout";
import DataTable from "../components/ui/DataTable";
import { CheckingTicket, LockingTicket } from '../components/tickets/Tickets';
import { canViewChildFeature, RECONCILE_VAT_COLUMNS } from '../libs/childUserPermission';

function Invoices() {
  const config = general.getLocalStorage("user_config");
  const showColName = canViewChildFeature(config, RECONCILE_VAT_COLUMNS.NAME);
  const showColQuantity = canViewChildFeature(config, RECONCILE_VAT_COLUMNS.QUANTITY);
  const showColMoney = canViewChildFeature(config, RECONCILE_VAT_COLUMNS.MONEY);
  const showColStatus = canViewChildFeature(config, RECONCILE_VAT_COLUMNS.STATUS);
  const [pageData, setPageData] = useState({ content: [] });
  const [pageInvoiceData, setPageInvoiceData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [checkingReviewData, setCheckingReviewData] = useState(null);

  const hasRun = useRef(false);
  const hasInvoiceRun = useRef(false);
  const [loaded, setLoaded] = useState(false);

  const [customerCodes, setCustomerCodes] = useState("");
  const [customerVats, setCustomerVats] = useState("");
  const [params, setParams] = useState({});
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(`/api/users/all`);
        const list = response.data.map(item => item.customerCode).filter(code => code);
        const uniqueList = [...new Set(list)];
        var joinedCodes = uniqueList.join(',');
        setCustomerCodes(joinedCodes);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
    searchInvoices();
  }, []);

  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchInvoices({ page: 0, keyword: searchValue });
  };

  const handleRefreshPage = (e) => {
    searchInvoices();
  };

  const searchInvoices = async (filter) => {
    if (window.calling2) return;
    window.calling2 = true;
    var params = general.getSession('form_invoice_filter');
    var formData = general.getFormData('#form_invoice_filter');
    Object.assign(params, formData);

    if (!hasInvoiceRun.current) {
      hasInvoiceRun.current = true;
      var oldParams = general.getSession('form_invoice_filter');
      Object.assign(params, oldParams);
      //setSearchQuery(params.keyword);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('form_invoice_filter', params);
    setParams(params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    try {
      var response = await axiosInstance.get('/api/invoices/searchInvoices', { params: filteredParams });
      setPageInvoiceData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setErrorMessage(error.message);
      console.error(error);
    } finally {
      window.calling2 = false;
    }
  }

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchInvoices({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchInvoices({ page: page - 1 });
  };

  const openInvoiceDetail = async (id) => {
    //modalReview.current?.showModal({ id: id });
    setCheckingReviewData({ id: id });
  };

  const handlePaymentConfirm = (param) => {
    var text = "Bạn có chắc chắn đã nhận đủ <b>" + general.formatNumber(param.fee) + " vnđ</b> cho hóa đơn này không?";
    general.openConfirm(async () => {



      try {
        var requestApi = `/api/invoices/completeInvoice`;
        const response = await axiosInstance.post(requestApi, { id: param.id });
        if (!response.data.success) {
          general.showFormError('.show .modal-body', response.data);
          toast.error(response.data);
          console.log(response.data);
          return;
        }
        console.log(response);
        toast.success(response.data.message);
        handleRefreshPage();
      } catch (error) {
        toast.error(error.message);
      }


    }, text)
  };

  const handleExportInvoice = async (param) => {
    try {
      var requestApi = `${API_URL_All}/api/invoices/exportInvoice?id=${param.id}`;
      const response = await fetch(requestApi, {
        method: 'GET',
        headers: general.headers()
      });

      if (!response.ok) {
        const errorBody = await response.json();
        toast.error(errorBody.message);
        return;
      }

      const blob = await response.blob();
      if (blob.size > 0) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Invoice_${param.id}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
    }
  };
  return (
    <div>
      <UserLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active">Danh sách VAT đối soát</button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" id="pane-02" role="tabpanel" aria-labelledby="nav-profile-tab">

                <div className="container-fluid pt-2">
                  <div className="text-start mb-2">
                    <div className="row">
                      <div className="col-md-5">
                        <form id="form_invoice_filter">
                          <div className="row">
                            <div className="col-md-7 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-4">Tìm kiếm</label>
                                <div className="col-md-8">
                                  <input className="form-control" type="text" name="keyword" placeholder="Nhập từ khóa..." autoComplete="off" value={params.keyword} onChange={(e) => handleSearchChange(e)} />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-5">
                              <div>
                                <button onClick={(event) => searchInvoices({ page: 0 })} type="button" className="btn btn-info btn-sm me-2 my-1 " >
                                  Tìm kiếm
                                </button>
                              </div>
                            </div>
                          </div>

                        </form>
                      </div>

                      <div className="col-4 col-md-1 p-0">

                      </div>

                    </div>

                  </div>
                </div>

                <section className="p-1">
                  <DataTable maxHeight="calc(100vh - 256px)" className="table-normal">
                    <table className="table table-striped table-bordered border-normal">
                      <thead className="table-primary">
                        <tr>
                          <th width="30px" className="sticky text-center">STT</th>
                          <th className="text-center"><span>Ngày đối soát</span></th>
                          {showColName && <th className="text-start"><span>Nội dung</span></th>}
                          {showColQuantity && <th className="text-center"><span>Số SP</span></th>}
                          {showColMoney && <th className="text-center"><span>Tổng tiền</span></th>}
                          {showColStatus && <th><span>Trạng thái</span></th>}
                          <th><span>Actions</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {pageInvoiceData.page && pageInvoiceData.page.content && pageInvoiceData.page.content.map((item, index) => (
                          <tr key={index}>
                            <td className="sticky text-center" title={`id: ${item.id}`}>{(pageInvoiceData.page.number * pageInvoiceData.page.size) + index + 1}</td>
                            <td className="text-center" title={general.formatTimeShort(item.createdAt)}>{general.formatDate(item.createdAt)}</td>
                            {showColName && <td className="text-start">{item.name}</td>}
                            {showColQuantity && <td className="text-center">{item.quantity}</td>}
                            {showColMoney && <td className="text-center">{general.formatNumber(item.money)}</td>}

                            {showColStatus && (
                              <td className="">
                                <CheckingTicket checkingId={item.checkingId} checkingName={item.checkingName} />
                              </td>
                            )}
                            <td className="text-center">
                              <span className="small-btn" title="Xuất file" onClick={(e) => { handleExportInvoice({ id: item.id }) }}><FaDownload /></span>
                              <span className="small-btn" onClick={(e) => { openInvoiceDetail(item.id) }}>xem</span></td>
                          </tr>
                        ))}
                      </tbody>
                      <tbody>
                        {message === '' && loaded && pageData.page && pageData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="11" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {message !== '' && (
                          <tr>
                            <td colSpan="11" className="text-center">{message}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                </section>
              </div>
            </div>
          </div>

          <div className="my-1 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageInvoiceData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>

          <input type="hidden" id="editor_lines" value="TMĐT,Line Thường,Line XT" />
          <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
          <input type="hidden" id="list_status" value="Đơn mới,Kho TQ,Xe Về VN,Kho VN,Đang Giao,Đã Nhận" />
          <input type="hidden" id="list_rateStatus" value="Chưa đối soát,Vào phiếu,Đã đối soát" />
          <input type="hidden" id="list_customers" value={customerCodes} />
          <input type="hidden" id="list_vats" value={customerVats} />

          {checkingReviewData && (
            <CheckingReview data={checkingReviewData} handleSearch={handleRefreshPage} />
          )}

        </div >
      </UserLayout>

    </div>
  );
}
export default Invoices;